export default __webpack_public_path__ + "static/media/slide3.cba376e5.jpg";